export const ckBTC_ID = "mxzaz-hqaaa-aaaar-qaada-cai";

export const ckBTC_MINTER_ID = "mqygn-kiaaa-aaaar-qaadq-cai";

export const ckBTC_DASHBOARD = "https://dashboard.internetcomputer.org/bitcoin";

export const DISSOLVE_FEE = "0.0000001";
